<template>
  <div>
    <div class="bank_des">
      <div class="pr30 bank_des_logo">
        <img :src="`/static/img/img_bank/${logo}.png`" onerror="javascript:this.src='/static/img/img_bank/bank_default.png';" alt="">
        <div>{{discountWebBaseCom.activeInfo.bankName}}</div>
      </div>
      <div class="part_padding">
        <div class="part_title">工作日</div>
        <div v-for="(item, index) in $store.state.publicData.acceptorWorkTime[logo].workInfo" :key="index" style="max-width: 400px;">
          <div v-html="item.desHtml"></div>
          <div class="more" v-if="item.more">
            详情&nbsp;>
            <div class="more_detail bs2" v-html="item.more"></div>
          </div>
        </div>
      </div>
      <div class="part_padding">
        <div class="part_title">周末&节假日</div>
        <div v-for="(item, index) in $store.state.publicData.acceptorWorkTime[logo].holidayInfo" :key="index" v-html="item.desHtml"></div>
      </div>
    </div>
    <div class="bank_tip">
      <div class="bank_tip_left">
        <i class="tip_prompt bank_tip_left_icon"></i>
        温馨提示：本页面价格均为基础价格（不包含可能存在的优惠），表中数据仅供参考，请以平台试算价格为准。<span class="update_time">更新时间：{{discountWebBaseCom.activeInfo.updateTime}}</span>
      </div>
      <div class="btn_text">
        <span @click="refresh">刷新</span>
        <span @click="download">下载</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['logo'],
  inject: ['discountWebBaseCom'],
  methods: {
    refresh () {
      this.discountWebBaseCom.refreshBankRate()
    },
    download () {
      this.discountWebBaseCom.downloadPage()
    },
  }
}
</script>

<style lang="less" scoped>
.pr30 {
  padding-right: 30px;
}
.bank_des {
  display: flex;
  align-items: stretch;
  margin-bottom: 28px;
  .bank_des_logo {
    min-width: 180px;
    display: flex;
    align-items: center;
    img {
      margin-right: 15px;
      width: 36px;
    }
    div {
      font-size: 16px;
      font-weight: bold;
    }
  }
  .part_padding {
    padding-left: 23px;
    border-left: 1px solid #e1e1e1;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-right: 80px;
    color: #333;
    text-align: left;
    line-height: 24px;
    flex-direction: column;
    display: flex;
    .part_title {
      color: #666;
    }
    /deep/ span {
      color: #e1241a;
    }
    .more {
      color: #e1241a;
      position: relative;
      cursor: pointer;
      .more_detail {
        position: absolute;
        width: 400px;
        top: 0;
        left: 56px;
        display: none;
        padding: 10px;
      }
    }
    .more:hover {
      .more_detail {
        display: block;
        background: #fff;
        color: #888;
      }
    }
  }
}
.bank_tip {
  display: flex;
  padding: 10px 36px 10px 20px;
  border: 1px solid #ffdeac;
  font-size: 12px;
  color: #f7a222;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff9e9;
  margin-bottom: 15px;
  .bank_tip_left {
    display: flex;
    align-items: center;
    .bank_tip_left_icon {
      display: inline-block;
      margin-right: 7px;
      width: 13px;
      height: 15px;
    }
  }
  .update_time {
    color: #666;
  }
  .btn_text {
    color: #e1241a;
    font-size: 14px;
    span {
      border-bottom: 1px solid #e1241a;
      cursor: pointer;
    }
    span:first-child {
      margin-right: 24px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/DiscountRateCardTop.vue